/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getRewardDashboardApi } from "services/rewards/rewards";
/* Project Import will be here */

export const types = {
    REWARDS_DASHBOARD_REQUEST: "rewardDashboard/REWARDS_DASHBOARD_REQUEST",
    REWARDS_DASHBOARD_SUCCESS: "rewardDashboard/REWARDS_DASHBOARD_SUCCESS",
    REWARDS_DASHBOARD_FAILURE: "rewardDashboard/REWARDS_DASHBOARD_FAILURE"
};

const initialState = {
    data: {},
    isLoading: false,
    error: null,
};

export const rewardDashboard = (state = initialState, action) => {
    switch (action.type) {
        case types.REWARDS_DASHBOARD_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.REWARDS_DASHBOARD_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.REWARDS_DASHBOARD_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        default:
            return state;
    }
};

/* Get reward dashboard details */
export const getRewardDashboard = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARDS_DASHBOARD_REQUEST });
        try {
            const response = await getRewardDashboardApi();
            dispatch({
                type: types.REWARDS_DASHBOARD_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.REWARDS_DASHBOARD_FAILURE,
                payload: { error: message }
            });
        }
    }
};